import React, { Component } from 'react';
import '../../css/pages/agents.css';
import moment from 'moment';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import { fetchTransactions } from '../actions/account';
import Pagination from '../components/Pagination';
import NoData from '../../assets/svgs/undraw_No_data_re_kwbl.svg';
import TransactionDetails from '../components/modals/TransactionDetails';

class TransactionHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: [],
      current_page: new URLSearchParams(props.location.search).get('page') || 1,
      limit: 10,
    };
  }

  handlePageChange = (data) => {
    const { limit } = this.state;
    fetchTransactions(data.currentPage, '', 'created_on', 'DESC', limit)
      .then(({ data: { transactions, page_info } }) => this.setState({
        transactions,
        current_page: page_info.page,
        total: page_info.total,
      }));
  };

  onSearch = e => {
    const { limit } = this.state;
    fetchTransactions(e.currentPage, e.currentTarget.value, 'created_on', 'DESC', limit)
      .then(({ data: { transactions, page_info } }) => this.setState({
        transactions,
        current_page: page_info.page,
        total: page_info.total,
      }));
  }

  render() {
    const {
      transactions, transaction, total, current_page, limit,
    } = this.state;
    return (
      <>
        <SideNav page="transactions" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="transactions" />
            {!transactions.length && (
              <div className="empty-state empty-state-transactions" hidden={transactions.length}>
                <img src={NoData} alt="Illustration for empty state" />
                <h3 className="empty-state__title">
                  There are no transactions yet.
                </h3>
                <p className="empty-state__subtext">
                  Transactions will show up here once you start transacting.
                </p>
              </div>
            )}
            <div className="filled--state transactions" hidden={!transactions.length}>
              <div className="filter-and-search">
                <div className="filter-box d-flex">
                  {/* <div className="input-group input-group-filter">
                    <div className="input-group-prepend">
                      <span className="input-group-text">Date:</span>
                    </div>
                    <input type="date" className="form-control" />
                  </div> */}
                  <div className="search-box">
                    <input type="search" className="form-control" placeholder="Search..." 
                    onInput={(e) => e.currentTarget.value === '' && this.onSearch(e)}
                    onKeyDown={(e) => e.key === 'Enter' && this.onSearch(e)} />
                  </div>
                </div>
                <div className="button-box">
                  <button type="submit" className="btn btn-primary">Export</button>
                </div>
              </div>
              <div className="row home__table">
                <div className="col-12">
                  <div className="default-card page-table">
                    <div className="empty-state no-result" hidden>
                      <img src="../../assets/svgs/undraw_search_re_ttoj.svg" alt="Illustration for search" />
                      <h3 className="empty-state__title">
                        No results found.
                      </h3>
                      <p className="empty-state__subtext">
                        Please check your spelling or try searching for something different.
                      </p>
                    </div>
                    <div className="">
                      <table className="table d-none d-lg-table table-hover">
                        <thead>
                          <tr>
                            <th className="date-time">DATE/TIME</th>
                            <th className="reference">REFERENCE</th>
                            <th className="narration">NARRATION</th>
                            <th className="amount">AMOUNT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {transactions.map((transaction) => (
                            <tr key={transaction.id} role="button" onClick={() => this.setState({ transaction })}>
                              <td className="date-time">
                                <span className="date">{moment(transaction.created_on).format('MMM DD, YYYY, h:mm:ss a')}</span>
                              </td>
                              <td className="reference">{transaction.reference}</td>
                              <td className="narration">{transaction.description}</td>
                              <td className={`amount ${transaction.entry === 'credit' ? 'text-success' : 'text-danger'}`}>{Number(transaction.amount).toLocaleString()}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="mobileListTable d-lg-none">
                        {transactions.map((transaction) => (
                          <div key={transaction.id} className="list" role="button" onClick={() => this.setState({transaction})}>
                            <div className="row listData">
                              <div className="col"><p className="reference">{transaction.reference}</p></div>
                              <div className="col">
                                <p className="date-time">
                                  <span className="date">{moment(transaction.created_on).format('MMM DD, YYYY, h:mm:ss a')}</span>
                                </p>
                              </div>
                            </div>
                            <div className="row listData">
                              <div className="col"><p className="narration">{transaction.description}</p></div>
                              <div className="col"><p className={`amount ${transaction.entry === 'credit' ? 'text-success' : 'text-danger'}`}>{Number(transaction.amount).toLocaleString()}</p></div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <Pagination
                    totalRecords={total}
                    pageLimit={limit}
                    pageNeighbours={1}
                    onPageChanged={this.handlePageChange}
                    initialPage={current_page} />
                </div>
              </div>
            </div>
          </div>
        </main>
        <TransactionDetails
          visible={!!transaction}
          data={transaction}
          onClose={() => this.setState({ transaction: null })} />
      </>
    );
  }
}

export default TransactionHistory;
